import React from "react";

function Loader() {
  return <p className="message">Loading...</p>;
}

export default Loader;
